import {ip} from '@/app/validators'

export default {
  $each: {ip}
}
